<div class="flex-container gap-16" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.heures_travaillees' | trans" [widget]="widget()" [draggable]="true" [editable]="true">
    <ng-content class="drag-handler" select='.drag-handler'></ng-content>
  </vl-widget-title>

  @if (metadata().loading || !dataComputed()) {
    <div class="h100 overflow-hidden">
      <ngx-skeleton-loader count="20" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else {
    <div class="flex-col gap-4 overflow-scroll fade-in pl-md-32 gap-4">
      @for (item of dataComputed(); track item.userInfosId) {
        <div class="flex-col w100 gap-8">
          <div class="flex-row align-center gap-8 px-4">
            <vl-user-info-card [userInfosId]="item.userInfosId" [inline]="true" class="grow"/>
            <div class="flex-row gap-4">
              <span class="body-2 on-background">{{ item.dureeTotale }} h</span>
              <vl-expand-button
                size="small"
                [expanded]="expanded === item.userInfosId"
                (expand)="expandUser(item.userInfosId)"
              />
            </div>
          </div>
          @if (expanded === item.userInfosId) {
            <div class="flex-col gap-4">
              @for (travail of item.travaux; track travail.denomination) {
                <div class="flex-row align-center gap-8">
                  <span class="caption on-background">{{ travail.denomination }}</span>
                  <span class="body-2 on-background">{{ travail.duree }} h</span>
                </div>
              }
            </div>
          }
        </div>
      } @empty {
        <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
      }
    </div>
  }
</div>
